import { render } from "./EmployeeDeniedServiceReports.vue?vue&type=template&id=73ba6d3a"
import script from "./EmployeeDeniedServiceReports.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedServiceReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__